import React__default from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';

const AppCreditCard = _ref => {
  let {
    expiry,
    focused,
    name,
    number,
    issuer
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Cards, {
    preview: true,
    expiry: expiry,
    focused: focused,
    name: name,
    number: number,
    issuer: issuer
  });
};
AppCreditCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppCreditCard"
};

export { AppCreditCard as default };
